<template>
  <div class="comment">
    <div class="top">
      <div class="querybox">
        <div>
          <p>圈子标题：</p>
          <el-input
            v-model="queryParams.circleTitle"
            placeholder="请输入圈子标题"
            clearable
          ></el-input>
        </div>
        <div>
          <p>评论状态：</p>
          <el-select
            v-model="queryParams.contentReviewStatus"
            placeholder="请选择评论状态"
          >
            <el-option
              v-for="item in getDictDatas(DICT_TYPE.CONTENT_REVIEW_STATUS)"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div>
          <p>评论时间：</p>
          <!-- <el-date-picker
            v-model="value"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            @change="timeChange"
          >
          </el-date-picker> -->
          <el-date-picker
            v-model="value"
            align="right"
            type="date"
            placeholder="选择时间"
            :picker-options="pickerOptions"
            @change="timeChange"
          >
          </el-date-picker>
        </div>
      </div>
      <div class="handlebox">
        <div class="btnbox">
          <el-popconfirm
            icon="el-icon-info"
            icon-color="red"
            title="确认删除选中的评论吗？"
            popper-class="customerdel-popover"
            @confirm="deleteFn()"
          >
            <el-button
              slot="reference"
              icon="el-icon-delete"
              class="add-btn"
              style="margin-right: 10px"
              >删除</el-button
            >
          </el-popconfirm>
          <el-button
            type="primary"
            icon="el-icon-refresh-right"
            class="reset-btn"
            @click="resetFn"
            >重置</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-search"
            class="search-btn"
            @click="search"
            >查询</el-button
          >
        </div>
      </div>
    </div>
    <div class="content">
      <el-table
        :data="tableData"
        tooltip-effect="dark"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection"> </el-table-column>
        <el-table-column prop="circleTitle" label="圈子标题"> </el-table-column>
        <el-table-column prop="userNickname" label="评论发布人">
        </el-table-column>
        <el-table-column
          prop="commentContent"
          label="评论内容"
          show-overflow-tooltip
          min-width="120"
        >
        </el-table-column>
        <el-table-column prop="createdTime" label="评论时间" min-width="120">
        </el-table-column>
        <el-table-column prop="contentReviewStatus" label="审核状态">
          <template slot-scope="{ row }">
            <el-button class="green-btn" v-if="row.contentReviewStatus === 1"
              >正常</el-button
            >
            <el-button
              class="blue-btn"
              v-else-if="row.contentReviewStatus === 0"
              >审核中</el-button
            >
            <el-button class="red-btn" v-else>禁用</el-button>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button class="textOrange-btn" @click="goEdit(scope.row)"
              >修改状态</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <pagination
        v-show="total > queryParams.pageSize"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="init"
      />
    </div>
    <!-- 修改状态 -->
    <el-dialog
      :visible.sync="statusVisible"
      width="30%"
      :before-close="statusClose"
      :show-close="false"
    >
      <div slot="title" class="title">
        <p>修改状态</p>
        <span @click="statusClose"><i class="el-icon-close"></i></span>
      </div>
      <div class="status-box">
        <el-radio-group v-model="contentReviewStatus">
          <template
            v-for="item in getDictDatas(DICT_TYPE.CONTENT_REVIEW_STATUS)"
          >
            <el-radio
              :key="item.value"
              :label="item.value"
              v-if="item.value !== 0"
              >{{ item.label }}</el-radio
            >
          </template>
        </el-radio-group>
        <el-input
          v-if="isInput"
          placeholder="请输入拒绝原因"
          show-word-limit
          maxlength="20"
          v-model="reviewComments"
        ></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="cancel-btn" @click="statusClose">取 消</el-button>
        <el-button type="primary" class="enter-btn" @click="sumbitStatus()"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getCommentList, editComment, deleteComment } from "@/api/circle";
export default {
  data() {
    return {
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        startTime: "",
        endTime: "",
        circleTitle: "",
        contentReviewStatus: "",
      },
      tableData: [],
      total: 0,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      value: "",
      selectList: [],
      statusVisible: false,
      contentReviewStatus: 1,
      itemInfo: {},
      reviewComments: "",
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  computed: {
    isInput() {
      return this.contentReviewStatus === 2 || this.contentReviewStatus === 3
        ? true
        : false;
    },
  },
  methods: {
    //获取评论列表
    async init() {
      const res = await getCommentList(this.queryParams);
      this.tableData = res.result.records;
      this.total = res.result.total;
    },
    // 查询
    search() {
      this.queryParams.pageNum = 1;
      this.init();
    },
    //重置
    resetFn() {
      this.queryParams.circleTitle = "";
      this.queryParams.contentReviewStatus = "";
      this.queryParams.startTime = "";
      this.queryParams.endTime = "";
      this.queryParams.pageNum = 1;
      this.value = "";
      this.init();
    },
    timeChange(event) {
      // console.log(event);
      if (event) {
        this.queryParams.startTime = this.$moment(event)
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss");
        this.queryParams.endTime = this.$moment()
          .endOf("day")
          .format("YYYY-MM-DD HH:mm:ss");
      } else {
        this.queryParams.startTime = "";
        this.queryParams.endTime = "";
      }
      // console.log(this.queryParams);
    },
    // 选择
    handleSelectionChange(val) {
      this.selectList = val.map((el) => {
        return el.id;
      });
    },
    // 删除
    async deleteFn() {
      if (this.selectList.length === 0) {
        this.$message.error("请先选择要删除的评论");
        return;
      }
      await deleteComment(this.selectList);
      this.$message.success("删除成功");
      this.init();
    },
    // 修改状态
    goEdit(item) {
      this.itemInfo = item;
      this.statusVisible = true;
    },
    statusClose() {
      this.statusVisible = false;
    },
    async sumbitStatus() {
      const { reviewComments, contentReviewStatus } = this;
      if (contentReviewStatus === 2 && !reviewComments) {
        this.$message.error("请输入拒绝原因");
        return;
      }
      if (contentReviewStatus === 3 && !reviewComments) {
        this.$message.error("请输入违规下架原因");
        return;
      }
      const params = {
        reviewComments,
        contentReviewStatus,
        id: this.itemInfo.id,
      };
      await editComment(params);
      this.statusVisible = false;
      this.reviewComments = "";
      this.contentReviewStatus = 1;
      this.init();
    },
  },
};
</script>
<style lang="scss" scoped>
.comment {
  .top {
    display: flex;
    justify-content: space-between;
    padding-bottom: 32px;
    ::v-deep .querybox {
      display: flex;
      align-items: center;
      > div {
        display: flex;
        align-items: center;
        margin-right: 20px;
        p {
          font-weight: 400;
          font-size: 14px;
          color: #262626;
          line-height: 20px;
          white-space: nowrap;
        }
        .el-input,
        .el-range-editor {
          width: 180px;
        }
        input::-webkit-input-placeholder {
          /* WebKit browsers */
          color: rgba(0, 0, 0, 0.25);
        }
        .el-input__inner {
          background: #ffffff;
          border-radius: 4px;
          border: 1px solid #d9d9d9;
        }
      }
    }
    .handlebox {
      display: flex;
      align-items: center;
    }
  }
  .content {
    .logo {
      display: flex;
      justify-content: center;
      img {
        width: 87px;
        height: 56px;
        border-radius: 4px;
      }
    }
  }
  ::v-deep .is-checked {
    .el-checkbox__inner {
      background-color: #ff5d2f;
      border-color: #ff5d2f;
    }
  }
  ::v-deep .is-indeterminate {
    .el-checkbox__inner {
      background-color: #ff5d2f;
      border-color: #ff5d2f;
    }
  }
  ::v-deep .status-box {
    width: 100%;
    .el-radio {
      font-weight: 400;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.85);
      line-height: 22px;
      .el-radio__label {
        color: rgba(0, 0, 0, 0.85);
      }
      .el-radio__inner {
        width: 16px;
        height: 16px;
        background: #ffffff;
        border-radius: 8px;
        border: 1px solid #d9d9d9;
      }
      .is-checked {
        .el-radio__inner {
          border: 1px solid #ff5d2f;
        }
        .el-radio__inner::after {
          width: 8px;
          height: 8px;
          background: #ff5d2f;
        }
      }
    }
    .el-input {
      margin-top: 24px;
    }
    input[aria-hidden="true"] {
      display: none !important;
    }

    .el-radio:focus:not(.is-focus):not(:active):not(.is-disabled)
      .el-radio__inner {
      box-shadow: none !important;
    }
  }
}
</style>
